export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'left',
    width: 70,
    showHeaderOverflow: true,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.form_label_mrpOutsourcingNo') || '委外加工订单编号',
    field: 'mrpOutsourcingOrderNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_materialName') || '物料名称',
    field: 'materialName',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_materialType') || '物料类型',
    field: 'v_materialType',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_materialSpec') || '物料规格',
    field: 'materialSpec',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_materialBatchUnit') || '物料单位',
    field: 'materialUnit',
    headerAlign: 'center',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_materialBatchDisplayName') || '物料显示名称',
    field: 'materialDisplayName',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.order_form_label_orderNo') || '订单编号',
    field: 'orderNo',
    headerAlign: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ncMaterialNo') || 'NC物料编码',
    field: 'ncMaterialNo',
    headerAlign: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.quantity') || '数量',
    field: 'quantity',
    headerAlign: 'center',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
    isTotalColumn: true,
  },

  {
    title: that.$l('INDEX.form_label_actualQuantity') || '实收数量',
    field: 'actualQuantity',
    headerAlign: 'center',
    width: 150,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 4,
        min: 0,
        max: 9999999999999.9999,
        clearable: true,
        controlsPosition: 'right',
        style: 'width:100%',
        size: 'mini',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
    isTotalColumn: true,
  },
]
